import React, { ReactNode } from 'react';

import Box from 'components/Box';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Hide = ({
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  display,
  // eslint-disable-line no-shadow
  ...props
}: {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  xsmall?: boolean;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  xlarge?: boolean;
  display?: string;
  children?: ReactNode;
}) => (
  <Box
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    display={[xs, sm, md, lg, xl].map((n) => (n ? 'none' : display || 'block'))}
  >
    {children}
  </Box>
);

export default Hide;
